import { Trans, useTranslation } from 'react-i18next'
import { Link, Outlet, useLocation } from 'react-router-dom'
import { Block, Button, Heading, Paragraph, IconArrowRight } from 'suomifi-ui-components'
import Footer from '../components/Footer'
import Header from '../components/Header'
import { AuthProvider } from '../provider/AuthProvider'




function Home() {
  const location = useLocation();
  const { t } = useTranslation();
  
  const isLoggedIn = AuthProvider.isAuthenticated; 
  
  return (
    <>
  <Header />
  <Block variant='main'>
    <Block variant="section">

      {location.pathname === "/" &&
        <>
          
            <Heading variant="h1">{t('homeView.welcome')}</Heading>
            <Paragraph>
              <Trans i18nKey="homeView.pageDescription">
                Tämä on demosivusto, joka on luotu <Link to={ t('ydUrl')}>yrityksen digitalous</Link> kokeiluja varten. 
              </Trans>
            </Paragraph>
            { isLoggedIn ?
              <>
              <Link to="/company">
                <Button iconRight={<IconArrowRight></IconArrowRight>}>{t("homeView.gotoCertificates")} (EWC / EUDI Wallet)</Button>
              </Link>
              <br/><br/>
              <Link to="/credentials">
                <Button iconRight={<IconArrowRight></IconArrowRight>}>{t("homeView.gotoCertificates")} (YD / Walt.ID)</Button>
              </Link>
              </>
              : 
              <div>
              <Paragraph>{t('homeView.pageInfo')}</Paragraph> 
              {/* <Link to="company">
                <Button>{t("homeView.applyLPID")} (authorized-mode)</Button>
              </Link> */}
              </div>
            }
   
        </>
      }
      <Outlet></Outlet>
    </Block>
  </Block>
  <Footer></Footer>
  </>
  )
}

export default Home